/* eslint-disable react/no-unescaped-entities */
import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { HomeStyle } from './Home.style';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../utils/auth';
import WithLoading from '../hocs/WithLoading/WithLoading';

const ScreensHome = (): JSX.Element | null => {
    const classes = HomeStyle();
    const { session, loading } = useAuth();

    const Placeholder = (): JSX.Element => <></>;
    const PlaceholderWithLoading = WithLoading(Placeholder);

    useEffect(() => {
        if (loading) return;
        if (session?.authenticated) return;
        // Not authenticated - trigger SSO login
        auth.login();
    }, [loading, session]);

    // If authenticated, redirect will be handled by MembershipRoute
    if (session?.authenticated) return <Redirect to="/" />;

    // Show loading while checking auth or redirecting to SSO
    return <PlaceholderWithLoading loading={true} error={false} />;
};

export default ScreensHome;
